import axios from 'axios'

class BiometricService {
  constructor() {
    this.baseUrl = '/api/v1/users/'
  }

  getVitalStatus(userId) {
    return axios.get(`${this.baseUrl}vitals_status/${userId}`)
  }

  saveVitals(vitalData) {
    return axios.post(`${this.baseUrl}update_vitals_status/`, vitalData)
  }
}

export const biometricService = new BiometricService()
